import { render, staticRenderFns } from "./completed-stage.vue?vue&type=template&id=673f1fcc&scoped=true&"
import script from "./completed-stage.vue?vue&type=script&lang=js&"
export * from "./completed-stage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f1fcc",
  null
  
)

export default component.exports